import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  ancillaryList: {},
  isLoading: false,
  error: "",
  hasData: false,
  ancillaryListStatus: {
    status: false,
    message: ""
  }
};
const ancillaryListSlice = createSlice({
  name: "ancillaryList",
  initialState,
  reducers: {
    ancillaryListRequest: state => {
      state.isLoading = true;
    },
    ancillaryListSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.ancillaryList = action.payload;
      state.ancillaryListStatus.status = true;
    },
    ancillaryListFailure: (state, action) => {
      state.error = action.payload;
      state.ancillaryList = "";
      state.isLoading = false;
      state.ancillaryListStatus.status = false;
    },
    resetAncillaryList: state => {
      state.isLoading = false;
      state.ancillaryList = {};
      state.ancillaryListStatus.status = false;
      state.hasData = false;
      state.error = "";
    }
  }
});
export const {
  ancillaryListRequest,
  ancillaryListSuccess,
  ancillaryListFailure,
  resetAncillaryList
} = ancillaryListSlice.actions;
export default ancillaryListSlice.reducer;